import { chatRoutes } from '@/Chat/chat.routes';
const chatModule = {
    routes: chatRoutes
};
export default chatModule;
